export const TODAY = new Date();

export const STAGES = [
  "Lead Qualification",
  "Resource Allocation",
  "Client Interview",
  "Proposal & Close",
];

export const CSM_LIST = [
  "Marcus Webb", "Lisa Park", "Sarah Chen", "Tom Rivet", "Kai Nakamura", "Amara Osei",
];
export const ALL_USERS = CSM_LIST;

export const PHASES = [
  { id:1, name:"Discovery & Scoping",   short:"Discovery"  },
  { id:2, name:"Internal Alignment",    short:"Alignment"  },
  { id:3, name:"Commercial & Contract", short:"Commercial" },
  { id:4, name:"Staffing & Readiness",  short:"Staffing"   },
  { id:5, name:"Launch & Delivery",     short:"Delivery"   },
  { id:6, name:"Ongoing Governance",    short:"Governance" },
  { id:7, name:"Renewal & Closure",     short:"Renewal"    },
];

export const DEPARTMENTS = [
  "Sales", "Client Success", "Delivery", "Recruitment",
  "Finance", "Legal", "Operations", "Engineering",
];

export const TASK_STATUSES = [
  "To Do", "In Progress", "Waiting on Internal", "Waiting on Client",
  "Blocked", "Ready for Review", "Done", "Cancelled",
];

export const CUST_PRIOS = ["Standard", "Strategic", "VIP", "Escalated"];

export const TASK_CATS = ["Sales", "Customer", "Projects", "Scoping", "Audit"];

export const CLIENT_CUST_PRIO = {
  "Halcyon Insurance": "Escalated",
  "Arcturus Bank":     "Strategic",
  "Celsius Group":     "VIP",
  "Nordveld Energy":   "Strategic",
  "Strata Logistics":  "Standard",
  "Vantage Retail":    "Standard",
};

export const inferTaskCat = dept =>
  dept === "Sales" ? "Sales"
  : ["Client Success","Delivery"].includes(dept) ? "Customer"
  : "Projects";

export const parseMentions = text =>
  [...new Set([...text.matchAll(/@([\w ]+)/g)].map(m => m[1].trim()))]
    .filter(m => ALL_USERS.some(u => u.toLowerCase().startsWith(m.toLowerCase())));
